module.exports = __webpack_public_path__ + "fonts/boxicons.8829e87f.ttf";